import React from 'react';
import { observer } from "mobx-react";
import uniqueId from 'lodash/uniqueId';
import { Icon } from 'components/Icon';
import { ReviewsIcon } from 'components/Svg';
import MenuItem from '../Menu/MenuItem';
import AdminMenuGroup from '../Menu/AdminMenuGroup';
import EcommerceMenu from '../Menu/EcommerceMenu';
import { DataMenu } from '../Menu/AdminMenuGroup';
import consoleStore from 'stores/Console/ConsoleStore';
import constants from 'Constants';
import * as auth from 'Auth';
import * as paths from 'Paths';
import * as utils from 'Utils';
import './styles.scss';




@observer
class OverviewMenu extends React.Component {
  constructor (props) {
    super(props);
    this.overviewUrl = paths.getPathReviewsOverview();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.REVIEWS_MENU.OVERVIEW);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.REVIEWS_SIDEBAR.OVERVIEW;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.REVIEWS_MENU.OVERVIEW}
        menuName="Overview"
        icon="home"
        href={this.overviewUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}


@observer
class AnalyticsMenu extends React.Component {
  constructor (props) {
    super(props);
    this.analyticsUrl = paths.getPathReviewsAnalytics();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.REVIEWS_MENU.ANALYTICS);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.REVIEWS_SIDEBAR.ANALYTICS;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.REVIEWS_MENU.ANALYTICS}
        menuName="Analytics"
        icon="bar-chart-alt-2"
        href={this.analyticsUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}


@observer
class ManageReviewsMenu extends React.Component {
  constructor (props) {
    super(props);
    this.reviewsUrl = paths.getPathProductReviews();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.REVIEWS_MENU.MANAGE_REVIEWS);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.REVIEWS_SIDEBAR.MANAGE_REVIEWS;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.REVIEWS_MENU.MANAGE_REVIEWS}
        menuName="Manage Reviews"
        icon="layer"
        href={this.reviewsUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}


@observer
class CollectorsMenu extends React.Component {
  constructor (props) {
    super(props);
    this.collectorsUrl = paths.getPathReviewsCollectors();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.REVIEWS_MENU.COLLECTORS);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.REVIEWS_SIDEBAR.COLLECTORS;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.REVIEWS_MENU.COLLECTORS}
        menuName="Collectors"
        icon="game"
        href={this.collectorsUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}



@observer
class WidgetsMenu extends React.Component {
  constructor (props) {
    super(props);

    this.reviewsWidgetsUrl = paths.getPathReviewsWidgets();
    this.starRatingsUrl = paths.getPathStarRatings();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.REVIEWS_MENU.WIDGETS);
    }
  }

  getSubMenus = () => {
    const { activeSidebar, history } = this.props;
    let subMenus = [{
        display: true,
        id: constants.REVIEWS_SIDEBAR.REVIEWS_WIDGETS,
        label: "Reviews Widgets",
        href: this.reviewsWidgetsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.reviewsWidgetsUrl),
        isActive: activeSidebar === constants.REVIEWS_SIDEBAR.REVIEWS_WIDGETS
    }, {
        display: true,
        id: constants.REVIEWS_SIDEBAR.STAR_RATINGS,
        label: "Star Ratings",
        href: this.starRatingsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.starRatingsUrl),
        isActive: activeSidebar === constants.REVIEWS_SIDEBAR.STAR_RATINGS
    }];

    return subMenus;
  };

  checkIsActive = () => {
    return this.getSubMenus().some((subMenu) => subMenu.isActive);
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = this.getSubMenus();

    return (
      <MenuItem
        menuId={constants.REVIEWS_MENU.WIDGETS}
        menuName="Widgets"
        icon="vector"
        subMenus={subMenus}
        isActive={this.checkIsActive()}
        {...this.props}
      />
    );
  }
}


@observer
class EmailsMenu extends React.Component {
  constructor (props) {
    super(props);

    const qs = {};
    qs['theme'] = constants.PRODUCT_REVIEWS;
    this.reviewsEmailsUrl = paths.getPathReviewsEmails();
    this.emailDomainsUrl = utils.appendQueryString(paths.getPathEmailDomains(), qs);
    this.emailProfilesUrl = utils.appendQueryString(paths.getPathEmailProfiles(), qs);
    this.emailSettingsUrl = utils.appendQueryString(paths.getPathEmailSettings(), qs);
    this.smtpProfilesUrl = utils.appendQueryString(paths.getPathSmtpProfiles(), qs);
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.REVIEWS_MENU.EMAILS);
    }
  }

  getSubMenus = () => {
    const { activeSidebar, history } = this.props;
    let subMenus = [{
        display: true,
        id: constants.REVIEWS_SIDEBAR.REVIEWS_EMAILS,
        label: "Reviews Emails",
        href: this.reviewsEmailsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.reviewsEmailsUrl),
        isActive: activeSidebar === constants.REVIEWS_SIDEBAR.REVIEWS_EMAILS
    }, {
        display: true,
        id: constants.REVIEWS_SIDEBAR.EMAIL_PROFILES,
        label: "Email Profiles",
        href: this.emailProfilesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.emailProfilesUrl),
        isActive: activeSidebar === constants.REVIEWS_SIDEBAR.EMAIL_PROFILES
    }, {
        display: true,
        id: constants.REVIEWS_SIDEBAR.EMAIL_SETTINGS,
        label: "Email Settings",
        href: this.emailSettingsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.emailSettingsUrl),
        isActive: activeSidebar === constants.REVIEWS_SIDEBAR.EMAIL_SETTINGS
    }, {
        display: true,
        id: constants.REVIEWS_SIDEBAR.SMTP_PROFILES,
        label: "SMTP Profiles",
        href: this.smtpProfilesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.smtpProfilesUrl),
        isActive: activeSidebar === constants.REVIEWS_SIDEBAR.SMTP_PROFILES
    }];

    return subMenus;
  };

  checkIsActive = () => {
    return this.getSubMenus().some((subMenu) => subMenu.isActive);
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = this.getSubMenus();

    return (
      <MenuItem
        menuId={constants.REVIEWS_MENU.EMAILS}
        menuName="Emails"
        icon="mail-send"
        subMenus={subMenus}
        isActive={this.checkIsActive()}
        {...this.props}
      />
    );
  }
}




@observer
class ConnectionsMenu extends React.Component {
  constructor (props) {
    super(props);
    this.connectionsUrl = paths.getPathReviewsConnections();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.REVIEWS_MENU.CONNECTIONS);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.REVIEWS_SIDEBAR.CONNECTIONS;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.REVIEWS_MENU.CONNECTIONS}
        menuName="Connections"
        icon="shape-circle"
        href={this.connectionsUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}





@observer
class ReviewsSidebar extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      activeMenu: "",
    };
  }

  componentDidMount() {
    auth.setCurrentProduct(constants.PRODUCT_REVIEWS);
  }

  updateActiveMenu = (activeMenu) => {
    if (this.state.activeMenu === activeMenu) {
      this.setState({activeMenu: ""});
      return;
    }

    this.setState({activeMenu: activeMenu});
  };

  render() {
    const account = consoleStore.account;

    return (
      <div className="sidebar sidebar-reviews">
        <div className="sidebar-head">
          <div className="head-icon"><ReviewsIcon /></div>
          <div className="head-title">Reviews</div>
        </div>

        <div className="menu-items">
          <div className="menu-group">
            <OverviewMenu
              isActive={this.state.activeMenu === constants.REVIEWS_MENU.OVERVIEW}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <AnalyticsMenu
              isActive={this.state.activeMenu === constants.REVIEWS_MENU.ANALYTICS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <ManageReviewsMenu
              isActive={this.state.activeMenu === constants.REVIEWS_MENU.MANAGE_REVIEWS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <CollectorsMenu
              isActive={this.state.activeMenu === constants.REVIEWS_MENU.COLLECTORS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <WidgetsMenu
              isActive={this.state.activeMenu === constants.REVIEWS_MENU.WIDGETS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <EmailsMenu
              isActive={this.state.activeMenu === constants.REVIEWS_MENU.EMAILS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <EcommerceMenu
              theme={constants.PRODUCT_REVIEWS}
              displayProducts={true}
              isActive={this.state.activeMenu === constants.REVIEWS_MENU.ECOMMERCE}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <ConnectionsMenu
              isActive={this.state.activeMenu === constants.REVIEWS_MENU.CONNECTIONS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <DataMenu
              isActive={this.state.activeMenu === constants.REVIEWS_MENU.DATA}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />
          </div>

          <AdminMenuGroup
            activeMenu={this.state.activeMenu}
            updateActiveMenu={this.updateActiveMenu}
            product={constants.PRODUCT_REVIEWS}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}



export { ReviewsSidebar };

